// Custom JavaScript functions
import { toastHelper } from "../Helpers/toastHelper";
import { storageHelper } from "../Helpers/storageHelper";
import ApiServices from "../Components/Services/ApiServices";
export const handleScroll = () => {
  const scroll = window.scrollY;
  const box = document.querySelector(".header-text")?.offsetHeight || 0;
  const header = document.querySelector("header")?.offsetHeight || 0;

  if (scroll >= box - header) {
    document.querySelector("header")?.classList.add("background-header");
  } else {
    document.querySelector("header")?.classList.remove("background-header");
  }
};

export const handleResize = () => {
  const width = window.innerWidth;
  const nav = document.querySelector(".header-area .nav");
  const menuTrigger = document.querySelector(".menu-trigger");

  if (width > 991) {
    // Desktop view
    if (nav) {
      nav.style.display = "flex";
      nav.style.removeProperty("display");
    }
    if (menuTrigger) {
      menuTrigger.classList.remove("active");
    }
  } else {
    // Mobile view
    if (nav) {
      nav.style.display = "none";
    }
  }
};

export const handleMenuTrigger = () => {
  const menuTrigger = document.querySelector(".menu-trigger");
  if (menuTrigger) {
    menuTrigger.addEventListener("click", function () {
      this.classList.toggle("active");
      const nav = document.querySelector(".header-area .nav");
      if (nav) {
        nav.style.display = nav.style.display === "none" ? "block" : "none";
      }
    });
  }
};

export const handleScrollToSection = (e) => {
  if (
    window.location.pathname.replace(/^\//, "") ===
    e.pathname.replace(/^\//, "") &&
    window.location.hostname === e.hostname
  ) {
    const target = document.querySelector(e.hash);
    if (target) {
      const width = window.innerWidth;
      if (width < 767) {
        document.querySelector(".menu-trigger")?.classList.remove("active");
        const nav = document.querySelector(".header-area .nav");
        if (nav) nav.style.display = "none";
      }
      window.scrollTo({
        top: target.offsetTop - 80,
        behavior: "smooth",
      });
      return false;
    }
  }
};

export const handleNavScroll = () => {
  const sections = document.querySelectorAll("section");
  const navLinks = document.querySelectorAll(".navbar-nav a");

  let current = "";

  sections.forEach((section) => {
    const sectionTop = section.offsetTop;
    if (window.pageYOffset >= sectionTop - 60) {
      current = section.getAttribute("id");
    }
  });

  navLinks.forEach((link) => {
    link.classList.remove("active");
    if (link.getAttribute("href") === `#${current}`) {
      link.classList.add("active");
    }
  });
};

// Dropdown handling functions
export const handleClickOutside = (dropdownRef, setIsDropdownOpen) => {
  const handleClick = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClick);
  return () => {
    document.removeEventListener("mousedown", handleClick);
  };
};

export const handleLogout = async (navigate) => {
  var item = storageHelper.getItem("user_type");
  if (item !== "User") {
    storageHelper.clearStorage();
    navigate("/signin");
    return;
  }

  try {
    const response = await ApiServices.post("LogOutUser", {});
    if (response && response.check) {
      storageHelper.clearStorage();
      navigate("/signin");
    }
  } catch (error) {
      toastHelper.error(error?.msg || "فشل تسجيل الخروج من الخادم");
  }
};
